/** @typedef {{ page: number, limit: number, total: number, total_pages: number }} PromptLibraryPagination */

/**
 * @param {unknown} data
 * @param {{ page?: number, pageSize?: number }} [opts]
 */
export function parseListResponse(data, opts = {}) {
  const page = Math.max(1, Number(opts.page) || 1);
  const pageSize = Math.max(1, Number(opts.pageSize) || 20);

  if (Array.isArray(data)) {
    const total = data.length;
    const total_pages = total === 0 ? 0 : Math.ceil(total / pageSize);
    const start = (page - 1) * pageSize;
    return {
      items: data.slice(start, start + pageSize),
      pagination: {
        page,
        limit: pageSize,
        total,
        total_pages,
      },
    };
  }

  const raw = data && typeof data === "object" ? data : {};
  const items = Array.isArray(raw.items) ? raw.items : [];
  const p = raw.pagination && typeof raw.pagination === "object" ? raw.pagination : {};

  const limit = Number(p.limit) || pageSize;
  const total = Number(p.total) ?? items.length;
  const total_pages =
    Number(p.total_pages) ||
    Number(p.totalPages) ||
    (total === 0 ? 0 : Math.ceil(total / limit));

  return {
    items,
    pagination: {
      page: Number(p.page) || page,
      limit,
      total,
      total_pages,
    },
  };
}

/** @param {unknown} pag */
export function normalizePagination(pag) {
  if (!pag || typeof pag !== "object") return null;
  const p = /** @type {Record<string, unknown>} */ (pag);
  const limit = Number(p.limit) || 20;
  const total = Number(p.total) || 0;
  const total_pages =
    Number(p.total_pages) ||
    Number(p.totalPages) ||
    (total === 0 ? 0 : Math.ceil(total / limit));
  return {
    page: Math.max(1, Number(p.page) || 1),
    limit,
    total,
    total_pages,
  };
}

/** @param {PromptLibraryPagination | null | undefined} pagination @param {number} [pageSize] */
export function shouldShowPagination(pagination, pageSize = 20) {
  if (!pagination) return false;
  if (pagination.total_pages > 1) return true;
  return Number(pagination.total) > pageSize;
}

/** @param {PromptLibraryPagination | null | undefined} pagination @param {import("../../context/TranslateContext")} [lang] */
export function formatPromptLibraryRange(pagination, lang) {
  if (!pagination?.total) return "";
  const from = (pagination.page - 1) * pagination.limit + 1;
  const to = Math.min(pagination.page * pagination.limit, pagination.total);
  const tpl =
    lang?.promptLibraryShowingRange || "Showing {from}–{to} of {total} prompts";
  return tpl
    .replace("{from}", String(from))
    .replace("{to}", String(to))
    .replace("{total}", String(pagination.total));
}
